// Tài khoản của tôi (khu Quản trị NPP): hồ sơ quản trị + bảo mật. Mật khẩu, 2FA, phiên đăng nhập là của
// User — dùng chung phần Bảo mật của web (API /auth/*), nên đổi mật khẩu ở đây giữ phiên web đang dùng;
// phiên quản trị bị thu hồi theo sẽ tự xin lại từ phiên web (lib/nppAdmin.ts).

import { PageHeader } from '@/components/ui/page-header'
import { SecurityTab } from '@/routes/Settings'
import { useNppAdmin } from '@/lib/nppAdmin'

export default function NppAccountPage() {
  const a = useNppAdmin()
  const nppName = a.npp ? (a.npp.isDefault ? a.npp.name : a.npp.displayName) : '—'
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Tài khoản" />
      <section className="rounded-xl border border-rule bg-raise p-5 sm:p-6">
        <dl className="grid gap-x-6 gap-y-3 text-sm sm:grid-cols-[10rem_minmax(0,1fr)]">
          <dt className="text-muted">Họ tên</dt>
          <dd className="font-medium text-ink">{a.name || '—'}</dd>
          <dt className="text-muted">Email</dt>
          <dd className="text-ink">{a.email || '—'}</dd>
          <dt className="text-muted">Nhà phân phối</dt>
          <dd className="text-ink">{nppName}</dd>
          <dt className="text-muted">Vai trò</dt>
          <dd className="text-ink">{a.isNppOwner ? 'Chủ nhà phân phối' : `Quản trị viên — ${a.permissions.length} quyền`}</dd>
        </dl>
      </section>
      <SecurityTab />
    </div>
  )
}
